import styled from "styled-components";

// Centered placeholder text shared by the rig/frac details panel and its value
// list (no coloring attribute, degraded domain, empty search result).
export const EmptyStateMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #a2aaad;
  font-size: 14px;
  text-align: center;
  padding: 20px;
`;
